import { Translate } from "../../constant/Translate"

const { EXPORT_EP0202 } = Translate

export const getProxyResponser = (proxyResponser?: string) =>
  proxyResponser ? EXPORT_EP0202 : ""
